module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/category-components/category/category-list/category-list.component.css
// module id = ./src/app/category-components/category/category-list/category-list.component.css
// module chunks = main